import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const businessService = {
    async getBusinessDetails() {
        try {
            const businessRef = doc(db, 'business', 'settings');
            const docSnap = await getDoc(businessRef);
            
            if (docSnap.exists()) {
                return { id: docSnap.id, ...docSnap.data() };
            } else {
                // Return default values if no business settings exist
                return {
                    id: 'settings',
                    quantityPerBox: 25, // Default box quantity in kg
                };
            }
        } catch (error) {
            console.error('Error fetching business details:', error);
            throw error;
        }
    }
}; 